var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirMultiplePagesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5H16.5L21 7V19.5",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21V7C3 6.60218 3.15804 6.22064 3.43934 5.93934C3.72064 5.65804 4.10218 5.5 4.5 5.5H14.252C14.4111 5.50014 14.5636 5.56345 14.676 5.676L17.824 8.824C17.88 8.8799 17.9243 8.94632 17.9545 9.01943C17.9847 9.09254 18.0002 9.1709 18 9.25V21C18 21.3978 17.842 21.7794 17.5607 22.0607C17.2794 22.342 16.8978 22.5 16.5 22.5H4.5C4.10218 22.5 3.72064 22.342 3.43934 22.0607C3.15804 21.7794 3 21.3978 3 21Z",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5V8.9C14 9.05913 14.0632 9.21174 14.1757 9.32426C14.2883 9.43679 14.4409 9.5 14.6 9.5H18",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirMultiplePagesEmpty);
export default __webpack_public_path__ + "static/media/iconoir_multiple-pages-empty.0c89e512a57e4e93f4ac0a99c80b8dc1.svg";
export { ForwardRef as ReactComponent };